var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * @fixme too much drunk code
 */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Close } from 'styled-cssgg';
import { animated, Transition } from '@react-spring/web';
import styled from 'styled-components';
import cx from 'classnames';
import { getRect } from '../tooltip/utils';
const StyledPreviewPage = styled(animated.div) `
  position: absolute;
  width: auto;
  padding: 0;
  background-color: ${() => 'var(--bg-color)'};
  z-index: 1000;
`;
const StyledCloseIcon = styled(animated.span) `
  --ggs: 0.5;
  cursor: pointer;
  border-radius: 100%;
  color: ${() => 'var(--text-color-0)'};
  background-color: ${() => 'var(--bg-color)'};
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 1000;
`;
const CloseIcon = (props) => {
    const handleClose = useCallback(() => {
        var _a;
        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props);
    }, [props.onClick]);
    return (React.createElement(StyledCloseIcon, { "data-role": "modal-title-icon", className: "preview-close-icon", role: "button", onClick: handleClose, style: Object.assign(Object.assign({}, props.style), { left: props.left, top: props.top, bottom: props.bottom, right: props.right }) }, props.children || React.createElement(Close, null)));
};
const container = document.body;
const PreviewPageContent = React.forwardRef((_a, ref) => {
    var _b;
    var { styles } = _a, props = __rest(_a, ["styles"]);
    const handleClose = useCallback(() => {
        var _a;
        (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
    }, [props.onClose]);
    return createPortal(React.createElement(StyledPreviewPage, { "data-role": "preview-page", className: "preview-page", style: Object.assign(Object.assign({}, styles), { opacity: 1 }), ref: ref },
        React.createElement(CloseIcon, { style: { opacity: styles.opacity }, onClick: handleClose }), (_b = props.children) === null || _b === void 0 ? void 0 :
        _b.call(props, {
            width: styles.width,
            height: styles.headerHeight,
        }),
        React.createElement("div", null, props.body)), container);
});
PreviewPageContent.displayName = 'PreviewPageContent';
const StyledPreview = styled.div `
  position: relative;
`;
export const Preview = (_a) => {
    var { trigger = 'hover', defaultVisible = false } = _a, props = __rest(_a, ["trigger", "defaultVisible"]);
    const parent = useRef(null);
    const hasControlled = 'visible' in props;
    const rect = useRef();
    const [visible, setVisible] = useState(defaultVisible);
    const controlledVisible = useMemo(() => {
        return hasControlled ? props.visible : visible;
    }, [visible, props.visible, hasControlled]);
    const handleMouseEnter = () => {
        trigger === 'hover' && setVisible(true);
    };
    const handleClick = () => {
        var _a;
        trigger === 'click' && setVisible(true);
        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props);
    };
    useEffect(() => {
        rect.current = getRect(parent);
    }, [parent]);
    const { width, height, top, left } = rect.current || {};
    console.log(width, height, top, left);
    const handleClose = useCallback(() => {
        var _a;
        (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
        setVisible(false);
    }, [props.onClose]);
    return (React.createElement(StyledPreview, { "data-role": "preview", onClick: handleClick, onMouseEnter: handleMouseEnter, className: cx('preview', props.className) },
        React.createElement(Transition, { items: props.visible, from: { width, height, headerHeight: height, opacity: 0, top, left }, enter: {
                width: container.clientWidth,
                top: 0,
                left: 0,
                height: container.clientHeight,
                headerHeight: 300,
                opacity: 1,
            }, leave: { width, height, opacity: 0, headerHeight: height, top, left }, onDestroyed: () => console.log('destroyed'), delay: 200 }, (styles, item) => {
            var _a;
            return !item ? (React.createElement(animated.div, { ref: parent, style: { display: 'inline-block' } }, (_a = props.children) === null || _a === void 0 ? void 0 : _a.call(props, {}))) : (React.createElement(PreviewPageContent, { visible: controlledVisible, parent: parent, body: props.body, styles: styles, onClose: handleClose }, props.children));
        }),
        ","));
};
